interface StarIconProps {
  size?: number;
  className?: string;
}

const StarIcon: React.FC<StarIconProps> = ({ size = 16, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
    >
      <path
        d="M8 1.8L9.88 5.6L14.08 6.22L11.04 9.18L11.76 13.36L8 11.38L4.24 13.36L4.96 9.18L1.92 6.22L6.12 5.6L8 1.8Z"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinejoin="round"
        fill="currentColor"
      />
    </svg>
  );
};

export default StarIcon;
